/**
 * VOICE_STATE_UPDATE о себе: что делать своему голосовому соединению (store/voice.ts).
 *
 * Такое событие приходит, когда мы сами переходим в другой канал, когда нас переносит или
 * отключает модератор и когда голос уходит на другое устройство. Рвать соединение — только
 * в двух последних случаях. Перенос обрабатывает VOICE_SERVER_UPDATE: в нём новая комната
 * и токен, а права подключиться туда самому у перенесённого может и не быть.
 * Чистая функция — чтобы проверить её без LiveKit и сторов.
 */
import type { VoiceState } from '@/types/api'

export function selfStateAction(
  cur: { guildId: string | null; channelId: string },
  vs: Pick<VoiceState, 'guild_id' | 'channel_id' | 'session_id'>,
  /** Сессия шлюза, с которой входили в голос: из ответа на вход, а не текущая — шлюз мог переподключиться. */
  joinedSession: string | null,
): 'keep' | 'drop' {
  // о прежнем месте: вышли из канала другого сервера или из звонка по дороге сюда
  if ((vs.guild_id ?? null) !== cur.guildId) return 'keep'
  // отключил модератор, вышли с другого устройства или из другой вкладки
  if (vs.channel_id === null) return 'drop'
  // канал, где мы есть или куда входим: микрофон, серверный мут и прочие обновления
  if (vs.channel_id === cur.channelId) return 'keep'
  // голос ушёл на другое устройство — там вошли в другой канал этого сервера
  if (joinedSession && vs.session_id && vs.session_id !== joinedSession) return 'drop'
  // перенёс модератор: новую комнату и токен принесёт VOICE_SERVER_UPDATE
  return 'keep'
}
